import React, { useEffect, useState } from "react";
import FormInput from "../components/controls/FormInput";
import { useAuth } from "../contexts/AuthContext";
import Button from "../components/controls/Button";

export default function UserProfilePage() {
  const { currentUser } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser?.id) return;

    async function loadProfile() {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/profile/${currentUser.id}`
        );

        if (!response.ok) {
          console.error("Erreur API:", await response.text());
          return;
        }

        const data = await response.json();
        setProfile(data);
      } catch (error) {
        console.error("Erreur de chargement:", error);
      } finally {
        setLoading(false);
      }
    }

    loadProfile();
  }, [currentUser]);

  async function saveProfile() {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/profile/${currentUser.id}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(profile),
      }
    );

    if (!response.ok) {
      alert("Erreur lors de la sauvegarde.");
      return;
    }

    alert("Profil sauvegardé !");
  }

  if (loading) return <div className="p-6">Chargement…</div>;
  if (!profile)
    return <div className="p-6">Impossible de charger le profil.</div>;

  return (
    <div className="w-full flex justify-center py-10 px-4 bg-gray-100">
      <div className="w-full max-w-2xl bg-white rounded-xl shadow-lg p-8 space-y-8">
        {/* Titre */}
        <div>
          <h1 className="text-3xl font-bold text-gray-800">Mon profil</h1>
          <p className="text-gray-500 mt-1">
            Gérez vos informations personnelles.
          </p>
        </div>

        <div className="bg-gray-50 border border-gray-200 rounded-lg px-4 py-3">
          <p className="text-sm text-gray-500">Adresse courriel associée</p>
          <p className="text-base font-semibold text-gray-800">
            {currentUser?.email}
          </p>
        </div>

        {/* Section informations */}
        <div className="space-y-6">
          <div className="space-y-4">
            <FormInput
              label="Nom complet"
              name="fullName"
              value={profile.fullName || ""}
              onChange={(name, value) =>
                setProfile((prev) => ({ ...prev, fullName: value }))
              }
              placeholder="Votre nom complet"
              required
            />

            <FormInput
              label="Téléphone"
              name="phone"
              value={profile.phone || ""}
              onChange={(name, value) =>
                setProfile((prev) => ({ ...prev, phone: value }))
              }
              placeholder="514-555-1234"
            />

            <div className="flex flex-col text-primary">
              <label className="text-gray-700 font-medium mb-1">
                Langue préférée
              </label>
              <select
                name="locale"
                value={profile.locale || ""}
                onChange={(e) =>
                  setProfile((prev) => ({ ...prev, locale: e.target.value }))
                }
                className="border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Choisir une langue</option>
                <option value="fr">Français</option>
                <option value="en">Anglais</option>
              </select>
            </div>
          </div>
        </div>

        {/* Bouton sauvegarder */}
        <div className="pt-4">
          <Button
            as="button"
            type="button"
            onClick={saveProfile}
            color="primary"
            size="md"
            className="w-full px-4 py-3 font-semibold"
          >
            Sauvegarder
          </Button>
        </div>
      </div>
    </div>
  );
}
